import * as React from 'react';
import { ListTypeToggle } from "../../../../js/lib/components/ListTypeToggle";
import { renderInShadow } from "../../../../js/lib/components/ShadowUtils";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEXT } from "../../../../js/lib/ext/Ext";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { ListsClientManager } from "../ClientManagers/ListsClientManager";
import { LoginClientManager } from "../ClientManagers/LoginClientManager";
import { ProhibitedListClientManager } from "../ClientManagers/ProhibitedListClientManager";
import { ChildSelectionList } from "./ChildSelectionList";
import { ListMiniPopupControl } from "./ListMiniPopupControl";
import { SimpleErrorDialog } from "./simpleErrorDialog";
import { SuccessMessageControl } from "./successMessageControl";
import { AccountHolder } from '@tlc/ls2pac/components/Account';
import { ListService, ListType } from '@tlc/ls2pac/components/pages/account/ListService';

const PROHIBITED_LIST_TYPE = "prohibitedListType";
const CONFIG_LIST_TYPE = "configListType";
const PERSONAL_LIST_TYPE = "personalListType";

export class AddToListControl extends ListMiniPopupControl {
  constructor(initialSearchTerm) {
    var options = {
      id: LS2PAC_CONSTANTS.Ids.SearchPage.addToListPopUp,
      //buttonId:  			LS2PAC_CONSTANTS.Ids.SearchPage.saveSearchButton,
      title: ApplicationData.language.addToListControl_header,
      showHeader: true,
      openEvent: LS2PAC_CONSTANTS.Events.onOpenAddToList,
      saveEvent: LS2PAC_CONSTANTS.Events.onAddToList,
      saveResponseEvent: LS2PAC_CONSTANTS.Events.onAddToListResponse,
      hasCreateNewButtonFunctionality: true,
    };

    super(options, initialSearchTerm);

    this.listOfListsId = this.id + "_listOfLists";
    this.lists = [];
    this.resourceIds = [];
    this.listOfLists = [];
    this.listExt = TLCEXT.Template(
      '#~lists#<li><a href="javascript:;" class="addToThisList" data-listId="##id##" data-listName="##name##">##name##</a></li>#/~#'
    );

    AccountHolder.subscribe(({patron}) => {
      this.children = patron?.children;
    });

  }
  addEvents(){
    var _this = this;
    $("#" + LS2PAC_CONSTANTS.Ids.mainPage).on(
      "click",
      ".addToList",
      function (event) {
        var resourceId = parseInt(
          $(event.currentTarget).attr("data-resourceId"),
          10
        );
        TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onOpenAddToList, {
          element: $(event.currentTarget),
          resourceIds: [resourceId],
        });
        return false;
      }
    );

    $("#" + LS2PAC_CONSTANTS.Ids.mainPage).on(
      "click",
      ".addToThisList",
      function (event) {
        _this.listId = parseInt($(event.currentTarget).attr("data-listId"), 10);
        if (isNaN(_this.listId)) {
          _this.listName = $(event.currentTarget).attr("data-listName");
          _this.formSubmit(true);
          _this.closePopUp();
          return false;
        }
        _this.formSubmit(false);
        _this.closePopUp();
        return false;
      }
    );
    super.addEvents();
  }
  removeEvents(){
    $("#" + LS2PAC_CONSTANTS.Ids.mainPage).off("click", ".addToList");
    $("#" + LS2PAC_CONSTANTS.Ids.mainPage).off("click", ".addToThisList")
    super.removeEvents();
  }
  async isGuardian() {
    const useGuardianProhibition =
      ApplicationData.supportedFunctionality.useGuardianProhibition;
    let hasChildren = false;
    if(useGuardianProhibition){
      const patron = await AccountHolder.fetchPatron();
      this.children = patron?.children;
      hasChildren = patron?.children?.length > 0;
    }
    return useGuardianProhibition && hasChildren;
  }
  toggleVisibleElements() {
    $("#" + this.isConfigContainerId).hide(); //we're using the toggle button instead

    //		if( this.lists.length == 0 ) {
    //			$( "#" + this.listOfListsId ).hide();
    //		} else {
    //			$( "#" + this.listOfListsId ).show();
    //		}
    this.toggleScrollClass();
  }
  toggleScrollClass() {
    if (this.lists.length > 5) {
      $("#" + this.id).addClass("scroll");
    } else {
      $("#" + this.id).removeClass("scroll");
    }
  }
  preLoadData(callback) {
    this.listOfLists = [];
    this.fetchLists(callback);
  }
  getList(listId) {
    var listOfLists = this.listOfLists[listId],
      _this = this;
    if (listOfLists !== undefined) {
      this.renderList(listOfLists);
    } else {
      this.getListCall(listId)(function (lists) {
        _this.listOfLists[_this.currentListOfLists] = lists;
        _this.renderList(lists);
      });
    }
  }
  getListCall(listId) {
    switch (listId) {
      case CONFIG_LIST_TYPE:
        return ListsClientManager.getConfigStaticLists;
      case PROHIBITED_LIST_TYPE:
        return (callback) => {
          ProhibitedListClientManager.getListSummaries().then((response) =>
            callback(response.listSummaries)
          );
        };
      default:
        return ListsClientManager.getStaticLists;
    }
  }
  renderList(lists) {
    this.listExt.overwrite(this.listOfListsId, { lists: lists });
  }
  async initControls() {
    const isConfigAdmin = AccountHolder.isConfigAdmin;
    const isGuardian = await this.isGuardian();

    if (
      isConfigAdmin === false &&
      isGuardian === false
    ) {
      return;
    }

    const container = document.querySelector(`#${this.id} .listControls`);
    const handleListTypeChange = (_, valueId) => {
        this.currentListOfLists = valueId;
        this.getList(this.currentListOfLists);
        if (valueId === PROHIBITED_LIST_TYPE) {
          // append the child list to the create form
          this.renderChildren();
        } else if (isGuardian) {
          this.removeChildren();
          // remove the child list from the create form
        }
    };
    renderInShadow(
      <ListTypeToggle
        defaultValue={this.currentListOfLists}
        isConfigAdmin={isConfigAdmin}
        isGuardian={isGuardian}
        onChange={handleListTypeChange}
      ></ListTypeToggle>,
      container,
      ApplicationData.language
    );

    if(isGuardian) {
      this.renderChildren();
    }
  }
  renderChildren() {
    this.removeChildren();
    this.childSelectionList = new ChildSelectionList(
      this.children,
      ApplicationData.locationConfiguration.getData()
    );
    this.childSelectionList.render(`#${this.newListInputHolderId}`);
  }
  removeChildren() {
    if (this.childSelectionList) {
      this.childSelectionList.destroy();
      this.childSelectionList = null;
    }
  }
  async fetchLists(callback) {
    var _this = this;
    if (!this.justNewList) {
      if (await this.isGuardian()) {
        this.currentListOfLists = PROHIBITED_LIST_TYPE;
      } else if (AccountHolder.isConfigAdmin) {
        this.currentListOfLists = CONFIG_LIST_TYPE;
      } else {
        this.currentListOfLists = PERSONAL_LIST_TYPE;
      }
      this.getListCall(this.currentListOfLists)(function (lists) {
        _this.listOfLists[_this.currentListOfLists] = lists;
        _this.lists = _this.listOfLists[_this.currentListOfLists];
        if (callback) callback();
      });
    } else {
      //TODO reachable?
      _this.lists = [];
      if (callback) callback();
    }
  }
  isConfig() {
    //$("#"+this.isConfigId).is(":checked")
    return this.currentListOfLists === CONFIG_LIST_TYPE;
  }
  isProhibited() {
    return this.currentListOfLists === PROHIBITED_LIST_TYPE;
  }
  handleAddToListResponse(response) {
    const { totalEResourcesNotAdded, success, successCount } = response;
    const language = ApplicationData.language;
    const resourceError = language.addToProhibitedListEResourceError;
    const successMessage = language.addToProhibitedListSuccess.replace(
      "%SUCCESS_COUNT%",
      successCount
    );
    const errorCountMessage = language.addToProhibitedListError.replace(
      "%ERROR_COUNT%",
      totalEResourcesNotAdded
    );

    if (totalEResourcesNotAdded === 0) {
      if (!success) {
        // generic failure
        SimpleErrorDialog.show(language.addToListErrorMessage);
      } else {
        // success message display
        SuccessMessageControl.show(successMessage);
      }
      return;
    }

    if (totalEResourcesNotAdded === 1 && successCount === 0) {
      // single eResource failure
      SimpleErrorDialog.show(resourceError);
      return;
    }

    const messages = [];

    if (successCount > 0) {
      messages.push(`<p>${successMessage}</p>\n`);
    }

    messages.push(`<p>${errorCountMessage} ${resourceError}</p>\n`);
    SimpleErrorDialog.show(messages.join(""));
  }
  async formSubmit(isDefaultList) {
    const listType = this.isConfig() ? ListType.Config : this.isProhibited() ? ListType.Prohibited : ListType.Personal;
    const listId = this.listId;  
    const resourceIds = this.resourceIds;
    if(listId) {
      this.listId = null;
        const response = await ListService.addToList(listId, listType, resourceIds);
        this.handleAddToListResponse(response);
      }
      else if(isDefaultList) {
        // We need to dissolve this feature. It causes more side effects than it can possibly be worth.
        const response = await ListService.createList(this.listName, listType, resourceIds, null);
        this.handleAddToListResponse(response);
      }
      else {
        const childIds = listType === ListType.Prohibited ? this.childSelectionList.getSelections() : null;
        const listName = $("#" + this.formId)
        .find("input:text")
        .val();
        const response = await ListService.createList(listName, listType, resourceIds, childIds);
        this.handleAddToListResponse(response);
      }
  }

}
